import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import useHasInvertedColors from '@hooks/useHasInvertedColors'
import useIsInHerotellingPage from '@hooks/useIsInHerotellingPage'

type WrapperProps = {
  isInHerotellingPage: boolean
  hasInvertedColors: boolean
}

const Wrapper = styled.div<WrapperProps>`
  ${({
    theme: {
      colors: { staticNeutral100, textDefault },
      typography: {
        bodycopy: {
          medium1: { bundledCSS: medium1BodyCopyCSS },
          small1: { bundledCSS: small1BodyCopyCSS },
        },
      },
    },
    isInHerotellingPage,
    hasInvertedColors,
  }) => css`
    ${small1BodyCopyCSS};
    color: ${hasInvertedColors || isInHerotellingPage
      ? staticNeutral100
      : textDefault};
    text-align: left;

    ${isInHerotellingPage && 'text-align: inherit'};
    ${desktopCSS(css`
      ${medium1BodyCopyCSS};
    `)}
  `}
`

const ArticleLead: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const isInHerotellingPage = useIsInHerotellingPage()
  const hasInvertedColors = useHasInvertedColors()

  return (
    <Wrapper
      isInHerotellingPage={isInHerotellingPage}
      hasInvertedColors={hasInvertedColors}
    >
      {children}
    </Wrapper>
  )
}

export default ArticleLead
